/* eslint-disable */
import React, {Component} from 'react';
import { Breadcrumb } from 'antd';
import PropTypes from 'prop-types';
import './style.less';

export default class BreadcrumbCon extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    emptyFunction() {

    }

    render() {
        const {pageName,pagePath,}=this.props;
        return (
            <div className={"breadcrumbCon"}>
                <span style={{fontSize:"14px"}}>当前位置：</span>
                <Breadcrumb>
                    <Breadcrumb.Item href={"/#/"}>首页</Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <a onClick={()=>this.emptyFunction()}
                           className={"lastA"}>{pageName}</a>
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>
        )
    }
}

BreadcrumbCon.propTypes = {
    pageName: PropTypes.string.isRequired,
    pagePath: PropTypes.string.isRequired,
    // sortState: PropTypes.object.isRequired,
    // sortKey: PropTypes.string.isRequired,
    // toggleDirection: PropTypes.func.isRequired
};
